const ATTACHMENT_UPLOAD_ROUTE_PREFIX = "/api/attachments/upload/";

export function resolveAttachmentUploadUrl(input: {
  readonly httpBaseUrl: string;
  readonly relativeUrl: string;
}): string {
  if (!input.relativeUrl.startsWith(ATTACHMENT_UPLOAD_ROUTE_PREFIX)) {
    throw new Error("Attachment upload URL did not use the expected upload route.");
  }
  const signedToken = input.relativeUrl.slice(ATTACHMENT_UPLOAD_ROUTE_PREFIX.length);
  if (!/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(signedToken)) {
    throw new Error("Attachment upload URL did not contain a valid signed token.");
  }
  if (input.relativeUrl.includes("?") || input.relativeUrl.includes("#")) {
    throw new Error("Attachment upload URL must not include a query or fragment.");
  }
  const baseUrl = new URL(input.httpBaseUrl);
  const basePath = baseUrl.pathname.endsWith("/")
    ? baseUrl.pathname.slice(0, -1)
    : baseUrl.pathname;
  const expectedPathPrefix = `${basePath}${ATTACHMENT_UPLOAD_ROUTE_PREFIX}`;
  const resolved = new URL(`${basePath}${input.relativeUrl}`, baseUrl);
  if (resolved.origin !== baseUrl.origin || !resolved.pathname.startsWith(expectedPathPrefix)) {
    throw new Error("Attachment upload URL resolved outside the selected environment.");
  }
  return resolved.toString();
}
